import { type FC, type ReactNode } from 'react';

import { Box } from '../Box';
import { type FeatureItem, FeatureList } from '../FeatureList';
import { Heading, Text } from '../Typography';

export type PackageHeaderProps = {
  /**
   * Main heading text
   */
  header: string;
  /**
   * Subheader content (can be text or React nodes)
   */
  subheader?: ReactNode;
  /**
   * Array of feature list sections to display
   */
  features?: FeatureItem[];
  /**
   * Additional CSS class names
   */
  className?: string;
};

const PackageHeader: FC<PackageHeaderProps> = ({
  header,
  subheader,
  features,
  className,
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="var(--spacing-2)"
      color="var(--text-primary)"
      className={className}
    >
      <Heading size="xs" fontWeight="bold">
        {header}
      </Heading>

      {subheader && <Text>{subheader}</Text>}

      {features && <FeatureList items={features} />}
    </Box>
  );
};

export default PackageHeader;
